import $ from 'jquery';
import * as bootstrap from "bootstrap";
import api from "./ajax";
import renderSubContractorRows from "./render-sub-contractor-row";
import renderJobHistory from "./render-job-history";
import {addSendTo, removeSendTo} from "./send-message";

const jobSubContractors = async () => {
	const subContractorTable = $('#subContractorsTable');
	let subContractors = []

	// Load subcontractors for job
	if (subContractorTable.length) {
		const jobId = subContractorTable.data('job-id');

		const data = await api.getSubContractorsForJob(jobId, this);

		if (!data.error) {
			subContractors = data.body;
			const html = renderSubContractorRows(subContractors);

			$('#loadingSubContractors').hide();
			subContractorTable.children('tbody').html(html);
		}
	}

	// Auto Show add subcontractor modal if no sub contractors
	let addContractorModal = document.getElementById('addSubContractorsModal');

	if (addContractorModal) {
		addContractorModal = new bootstrap.Modal(addContractorModal);
		addContractorModal.show();
	}

	// Add 1 truck of contractor to job
	$('#subContractorTable').on('click', '.add-contractor', async (e) => {
		const {currentTarget} = e;
		const activeBtn = $(currentTarget);
		const contractorId = parseInt(activeBtn.data('id'));
		const jobId = parseInt(activeBtn.data('job-id'));

		const data = {
			job: jobId,
			sub_contractor: contractorId,
		}

		activeBtn.children('.text').hide();
		activeBtn.children('.fa-spinner').show();

		// Make Ajax request
		const response = await api.addSubContractor(data, this);

		if (!response.error) {
			const {trucks_available: trucksAvailable} = response.body;
			const trucksAvailableSpan = activeBtn.closest('tr').find('.trucks-available');

			activeBtn.children('.fa-spinner').hide();
			activeBtn.children('.text').show();
			activeBtn.addClass('selected');

			if (trucksAvailable < 1) {
				activeBtn.prop('disabled', true);
			}

			trucksAvailableSpan.html(trucksAvailable);

			// Add it to the table
			subContractors.push(response.body);
			const html = renderSubContractorRows(subContractors);
			subContractorTable.children('tbody').html(html);
		}
	});

	// Send the job to selected sub contractors
	$('#sendJob').on('click', async (e) => {
		const {currentTarget} = e;
		const sendButton = $(currentTarget);
		const modalBody = sendButton.parents('.modal__body');
		const jobId = subContractorTable.data('job-id');
		const jobHistoryList = $('#jobHistoryList');
		const sendTo = $('#subContractorsTable .send-to-driver:checked').get().map(e => {
			return $(e).val();
		});
		let sendModal = document.getElementById('confirmSendModal');

		sendModal = bootstrap.Modal.getInstance(sendModal);
		modalBody.children('.sending').addClass('show');

		const response = await api.sendJob(sendTo, this);

		if (response.error) {
			return;
		}

		const updatedContractors = await api.getSubContractorsForJob(jobId, this);

		if (updatedContractors.error) {
			return;
		}

		subContractors = updatedContractors.body;
		const html = renderSubContractorRows(subContractors);

		subContractorTable.children('tbody').html(html);

		// Update the Job History
		const jobHistory = await api.getJobHistory(jobId, this);

		if (jobHistory.error) {
			return;
		}

		const jobHistoryHtml = renderJobHistory(jobHistory.body)

		// Build HTML for job history items and then replace html in history list
		jobHistoryList.html(jobHistoryHtml);

		sendModal.hide();
		modalBody.children('.sending').removeClass('show');
	});

	$('#toggleSendToAll').on('click', (e) => {
		const {currentTarget} = e;
		const toggleCheckboxes = $(currentTarget);

		$('.send-to-driver').prop('checked', toggleCheckboxes.prop('checked')).change();
	});

	// Disable / Enable send buttons based on drivers selected
	$('#subContractorsTable').on('change', ['.send-to-driver', '#toggleSendToAll'], () => {
		const ready = $('#preSendJob').data('ready');

		const disabled = $('.send-to-driver:checked').length > 0 && ready;

		$('#preSendJob').prop('disabled', !disabled);
		$('#preSendMessage').prop('disabled', !disabled);
		$('#bulkMenuActions').prop('disabled', !disabled);
	});

	// On remove subcontractor from job modal open
	const removeContractorModal = document.getElementById('confirmRemoveContractorModal');

	if (removeContractorModal) {
		removeContractorModal.addEventListener('show.bs.modal', (event) => {
			const button = event.relatedTarget;
			let name = button.getAttribute('data-name');
			let ids = button.getAttribute('data-id');
			let sent = button.getAttribute('data-sent');

			if (ids === 'bulk') {
				// Get the Ids of the selected sub contractors
				const selected = $('#subContractorsTable .send-to-driver:checked').get().map(e => {
					return $(e).val();
				});

				ids = selected.join(',');
				name = 'the selected Sub Contractors';

				// Check if any of the selected contractors have been sent
				sent = subContractors.some(sc => selected.includes(sc.id.toString()) && sc.sent);
			}

			// Show appropriate message based on sent status
			if (sent === 'true' || sent === true) {
				$('#removeContractorMessage').addClass('d-none');
				$('#removeContractorSentMessage').removeClass('d-none');
				$('#removeContractorNameSent').html(name);
			} else {
				$('#removeContractorMessage').removeClass('d-none');
				$('#removeContractorSentMessage').addClass('d-none');
				$('#removeContractorName').html(name);
			}

			$('#removeSubContractor').data('id', ids);
		});
	}

	$('#removeSubContractor').on('click', async (e) => {
		const {currentTarget} = e;
		const idsToRemove = $(currentTarget).data('id');
		const activeBtn = $(currentTarget);

		activeBtn.children('.fa-spinner').show();

		// Convert comma separated string to array
		const ids = idsToRemove.split(',').map(e => parseInt(e));

		// Loop through each id and remove it from the job
		for (let i = 0; i < ids.length; i++) {
			const response = await api.removeSubContractor(ids[i], this);

			if (response.error) {
				return;
			}

			activeBtn.children('.fa-spinner').hide();

			// Remove it from the table
			const removed = subContractors.splice(subContractors.findIndex((e) => {
				return e.id === ids[i];
			}), 1);

			const html = renderSubContractorRows(subContractors);

			if( removed.length > 0) {
				const {sub_contractor: subContractor} = removed[0];
				const span = $(`#subContractor${subContractor} .trucks-available`);
				const btn = $(`#subContractor${subContractor} .add-contractor`);
				const initial = parseInt(span.html(), 10)
				const trucksNowAvail = initial + 1;

				span.html(trucksNowAvail);
				btn.prop('disabled', false);
			}

			subContractorTable.children('tbody').html(html);

			bootstrap.Modal.getInstance(removeContractorModal).hide();
		}
	});

	$('#subContractorsTable').on('change', '.send-to-driver', (e) => {
		const {currentTarget} = e;
		const contId = $(currentTarget).val();
		const checked = $(currentTarget).is(':checked');

		if (checked) {
			addSendTo({detailed_name: '', id: contId});
		} else {
			removeSendTo('id', contId);
		}
	});
};

export default jobSubContractors;
